(() => {
  'use strict';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = matchMedia('(min-width: 1000px)');
  const body = document.body;
  let revealObserver;
  let sceneObserver;
  let frame = 0;
  const active = new Set();
  function enabled() { return body.dataset.motion === 'true' && !reduce.matches && !window.Shopify?.designMode; }
  function reveal(element) {
    element.classList.remove('motion-pending');
    element.classList.add('motion-visible');
    revealObserver?.unobserve(element);
  }
  function draw() {
    frame = 0;
    if (!enabled()) return;
    const vh = innerHeight;
    active.forEach((scene) => {
      if (!scene.isConnected) { active.delete(scene); return; }
      const rect = scene.getBoundingClientRect();
      const progress = Math.max(-1, Math.min(1, (vh / 2 - (rect.top + rect.height / 2)) / vh));
      const hero = scene.matches('.hero-stage');
      const shift = progress * (desktop.matches ? 24 : 9);
      scene.style.setProperty('--scene-y', `${shift.toFixed(2)}px`);
      scene.style.setProperty('--scene-scale', String(1 + Math.abs(progress) * (hero ? .012 : .018)));
      scene.style.setProperty('--scene-angle', `${(progress * (desktop.matches ? 1.2 : .3)).toFixed(2)}deg`);
    });
  }
  function schedule() { if (!frame && active.size && enabled()) frame = requestAnimationFrame(draw); }
  function setup() {
    revealObserver?.disconnect();
    sceneObserver?.disconnect();
    active.clear();
    document.querySelectorAll('.motion-pending').forEach(reveal);
    document.querySelectorAll('[data-scene]').forEach((scene) => {
      ['--scene-y', '--scene-scale', '--scene-angle'].forEach((name) => scene.style.removeProperty(name));
    });
    body.classList.toggle('experience-motion', enabled());
    if (!enabled() || !('IntersectionObserver' in window)) return;
    revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => { if (entry.isIntersecting) reveal(entry.target); });
    }, { threshold: .08, rootMargin: '0px 0px -24px 0px' });
    const targets = document.querySelectorAll('.benefit, .story-grid h2, .story-copy > .rte, .story-answer, .how .section-heading, .step, .how-note, #produit .product-copy > *, .subscription-inner, .faq-grid > div:first-child, .faq-list details, .interest-grid > div');
    targets.forEach((element) => {
      element.classList.add('motion-item');
      if (element.getBoundingClientRect().top > innerHeight * .92 && !element.contains(document.activeElement)) {
        element.classList.remove('motion-visible');
        element.classList.add('motion-pending');
        revealObserver.observe(element);
      } else reveal(element);
    });
    document.querySelectorAll('.steps, .benefits-grid').forEach((group) => {
      Array.from(group.children).forEach((child, index) => child.style.setProperty('--reveal-delay', `${Math.min(index, 3) * 65}ms`));
    });
    sceneObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => { if (entry.isIntersecting) active.add(entry.target); else active.delete(entry.target); });
      schedule();
    }, { rootMargin: '80px' });
    document.querySelectorAll('.hero-stage, #produit .product-card').forEach((scene) => {
      scene.setAttribute('data-scene', '');
      sceneObserver.observe(scene);
    });
  }
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  addEventListener('pageshow', (event) => { if (event.persisted) setup(); });
  document.addEventListener('focusin', (event) => { const parent = event.target.closest('.motion-pending'); if (parent) reveal(parent); });
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:unload', setup);
  reduce.addEventListener('change', setup);
  desktop.addEventListener('change', schedule);
  document.querySelectorAll('.mobile-nav').forEach((menu) => {
    menu.addEventListener('toggle', () => menu.querySelector('summary')?.setAttribute('aria-expanded', String(menu.open)));
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.mobile-nav[open]').forEach((menu) => { if (!menu.contains(event.target)) menu.open = false; });
  });
  setup();
})();
